
import { defineComponent, computed, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";
import {
  ErrorMessageFilter,
  IErrorResponse,
  isErrors,
  Roles,
  consts,
} from "@/services/Models";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { AxiosResponse } from "axios";
import { IContract } from "../services/Models";

export default defineComponent({
  name: "AdminContractUserCreate",
  components: { ErrorMessage },
  setup() {
    const resource = store.useResource();
    const router = useRouter();
    const route = useRoute();
    const contractID = Number.parseInt(route.params.id as string);
    const contract = computed(() =>
      resource.data.contracts.find((x) => x.id == contractID)
    );
    const errors = ref<IErrorResponse[]>([]);
    const errorMessages = computed(() => ({
      email: ErrorMessageFilter(errors.value, "Mail"),
    }));

    const user = reactive({
      email: "",
      name: "",
    });

    // ユーザ追加(契約更新)
    const apply = async () => {
      if (!contract.value) return;
      const updateModel = JSON.parse(
        JSON.stringify(contract.value)
      ) as IContract;

      updateModel.users.push({
        id: undefined,
        email: user.email,
        name: user.name,
        role: Roles.None,
      });

      await resource
        .saveContract(updateModel)
        .then(
          async () => await router.push({ name: routeNames.AdminContractUsers })
        )
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.updateContractFailure);
          }
        });
    };

    // キャンセル
    const cancel = async () => {
      await router.push({ name: routeNames.AdminContractUsers });
    };
    return {
      contract,
      user,
      apply,
      cancel,
      errorMessages,
      consts,
    };
  },
});
